import PageBoundary from './PageBoundary'

export default PageBoundary
